import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GroupType} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class DeclineReasonService {
    url = '/api/v1/admin/decline-reasons';

    constructor(public http: HttpClient) {
    }

    addDeclineReason(declineReason: any): any {
        return this.http.post<GroupType>(this.url, declineReason);
    }

    getDeclineReasons(): any {
        return this.http.get(this.url);
    }

    removeDeclineReason(id: number): any {
        return this.http.delete(`${this.url}/${id}`);
    }
}
